import { darkPalette } from "../palette";
// MuiDialog
export const MuiDialog = {
  MuiDialog: {
    styleOverrides: {
      root: {
        "& .MuiDialog-paper": {
          backgroundImage: "none",
        },
        "& .MuiPaper-root .MuiGrid-root": {
          backgroundColor: darkPalette.background.paper,
          color: darkPalette.text.primary,
          "& h6": {
            color: darkPalette.text.primary,
          },
        },
      },
    },
  },
};
